import React, { useEffect, useRef } from "react";
import { _t } from "app/i18n/i18n";
import { postPreferences } from "api/preferences/postPrefrences";
import { Preferences } from "components/Preferences/Preferences";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";
import ErrorBoundary from "lib/ErrorBoundary";

export const PreferencesDialog = ({ chatOpen = false, panelWidth = 0 }) => {
  const preferences = useSelector((state) => state.preferences);
  const show = useSelector((state) => state.misc.showPreferencesDialog);
  const dispatch = useDispatch();
  const initialMaxWidthRef = useRef(null);
  const showPreferencesDialog = (isVisible) =>
    dispatch(miscSlice.actions.set({ key: "showPreferencesDialog", value: isVisible }));

  useEffect(() => {
    if (show && initialMaxWidthRef.current === null) {
      const modalDialog = document.querySelector(".modal-dialog");
      if (modalDialog) {
        const computedStyle = window.getComputedStyle(modalDialog);
        initialMaxWidthRef.current = parseInt(computedStyle.maxWidth) || 800;
      }
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      const modalDialog = document.querySelector(".modal-dialog");
      if (modalDialog && chatOpen && initialMaxWidthRef.current !== null) {
        const availableWidth = window.innerWidth - panelWidth;
        modalDialog.style.maxWidth = `${Math.min(availableWidth - 60, initialMaxWidthRef.current)}px`;
        modalDialog.style.transform = `translateX(${-panelWidth / 2}px)`;
      } else if (modalDialog) {
        modalDialog.style.removeProperty("max-width");
        modalDialog.style.removeProperty("transform");
      }
    }
  }, [show, chatOpen, panelWidth]);

  return (
    <ErrorBoundary>
      <Modal show={show} onHide={() => showPreferencesDialog(false)} size="lg" scrollable={true}>
        <Modal.Header className="bg-dark">
          <Modal.Title>
            <h3 className="font-weight-lighter text-white">{_t("Preferences")}</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-dark">
          <Preferences />
        </Modal.Body>

        <Modal.Footer className="bg-dark">
          <Button variant="secondary" onClick={() => showPreferencesDialog(false)}>
            {_t("Close")}
          </Button>
          <Button variant="primary" onClick={() => postPreferences(preferences) && showPreferencesDialog(false)}>
            {_t("Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </ErrorBoundary>
  );
};
